import { RouteObject } from "react-router-dom";
import LegacyIFrame from "../pages/Legacy/LegacyIFrame";

export const staffLegacyPaths = [
  "/admin_firmsocialmedia.asp",
  "/admin_firmpracticeheads.asp",
  "/admin_wsgcontacts.asp",
  "/financial.asp",
  "/payments.asp",
  "/wsg_admin15.asp",
  "/wsg-success-stories.asp",
  "/admin_blogrolls.asp",
  "/admin_manage_blogposts.asp",
  "/howto_admin.asp",
  "/faq_admin.asp",
  "/bodupdate.aspx",
  "/believeupdate.aspx",
  "/wsg_admin27c.asp",
  "/admin_manage_referrals.asp",
  "/admin_manage_secondments.asp",
  "/admin_manage_dealmaker.asp",
  "/admin_assessmentfees.asp",
  "/admin_manage_bizguide.asp",
  "/membertomember.aspx",
  "/wsg_adminguides.asp",
  "/listing_edit.asp",
  "/admin_importmodule.asp",
  "/admin_rssfeedsync.asp",
  "/admin_Rssfeeds.asp",
  "/dashboard_powerbi.asp",
  "/wsg_adminstat.asp",
  "/dashboard_ganalytics.asp",
  "/dashboard_sendgrid.asp",
  "/admin_manage_metadata.asp",
  "/admin_professional_metadata.asp",
  "/admin_invited.asp",
  "/wsg_admin17.asp",
  "/history_logs.asp",
  "/admin_database.asp",
  "/admin_notificationemails.asp",
  "/admin_manage_networkwire.asp",
  "/wsg_admin2.asp/*",
  "/admin_manage_referrals",
  "/unsubscriber-list",
  "/trigger-email-templates",
  "/wsg_admin22.asp",
  "/wsg_submitemails.asp",
  "/wsg_admin.asp",
  "/admin_unsubscribe.asp",
  "/trigger_emails.asp",
  "wsg_admin13.asp",
];

const generateLegacyRoutes = (paths: string[]): RouteObject[] => {
  return paths.map((path) => ({
    path,
    element: (
      <LegacyIFrame isStaffUrl />
    ),
  }));
};

export const StaffLegacyRoutes: RouteObject[] =
  generateLegacyRoutes(staffLegacyPaths);
